import type { FaireProductEntity } from "../../entity_types/product";

export const p_yusw2s7hhj: FaireProductEntity = {
  token: "p_yusw2s7hhj",
  type: "product",
  name: "zephaniah 3:17 tree stump scripture print",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/e09a874c98ec283d244a79c5845917de05a20a53c01d29731584e531d2e88fe4.jpeg",
  galleryImageUrls: [],
  priceDollars: 11,
  description:
    "Fill your walls with beauty and truth. Display this lovely print around your house for daily reminders of God's goodness.\n\nTree stump watercolor illustration with Zephaniah 3:17.",
  tags: [],
  msrpDollars: 22,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:15:11.382Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
